import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Image } from 'foundations-components/transitional/components/Image';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { HamburgerMenuIcon } from 'foundations-assets/icons/components/HamburgerMenuIcon';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAppSelector } from '../redux/index';
import { selectPortalDisplayName } from '../features/PublicPortalSettings/PublicPortalSettingsSelectors';
import { useBrandSettings } from '../hooks/usePortalPlatformData';
import { getMembershipLogoutUrl } from '../constants/urls';
import { trackInteraction } from '../utils/usageTracker';
import { useIsMobileView } from '../hooks/useWindowSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  appTitleFallback: 'top-bar-app-title-fallback',
  signOutLink: 'top-bar-sign-out-link'
};
export const TopBar = ({
  onHamburgerClick
}) => {
  const companyName = useAppSelector(selectPortalDisplayName);
  const brandSettings = useBrandSettings();
  const isMobileView = useIsMobileView();
  const logo = (brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.primaryLogo) || (brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.logo);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    gap: isMobileView ? '300' : '600',
    paddingInline: isMobileView ? '400' : '600',
    paddingBlock: isMobileView ? '300' : '500',
    borderBlockEndStyle: "solid",
    borderBlockEndColor: "border-transitional-core-subtle",
    borderBlockEndWidth: "100",
    backgroundColor: "fill-surface-default",
    children: [isMobileView && /*#__PURE__*/_jsx(IconButton, {
      use: "transparent",
      onClick: onHamburgerClick,
      "aria-label": I18n.text('app.nav.visibilityToggle.expandLabel'),
      children: /*#__PURE__*/_jsx(HamburgerMenuIcon, {})
    }), (logo === null || logo === void 0 ? void 0 : logo.src) && /*#__PURE__*/_jsx(View, {
      borderInlineEndWidth: "100",
      borderInlineEndColor: "border-core-default",
      borderInlineEndStyle: "solid",
      flexShrink: 0,
      paddingInlineEnd: isMobileView ? '300' : '600',
      children: /*#__PURE__*/_jsx(Image, {
        src: logo.src,
        alt: logo.alt || I18n.text('topbar.logoAltText'),
        maxBlockSize: isMobileView ? '24px' : '32px'
      })
    }), /*#__PURE__*/_jsx(View, {
      overflow: "hidden",
      minInlineSize: "0",
      children: /*#__PURE__*/_jsx(Text, {
        typography: isMobileView ? 'heading-200' : 'heading-400',
        textOverflow: "ellipsis",
        textWrap: "nowrap",
        children: companyName !== null && companyName !== void 0 ? companyName : /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": TEST_IDS.appTitleFallback,
          message: "app.htmlTitle"
        })
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "end",
      flexGrow: 1,
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(Link, {
        href: getMembershipLogoutUrl(window.location.origin),
        use: "unstyled",
        typography: "body-125",
        "data-test-id": TEST_IDS.signOutLink,
        onClick: () => trackInteraction('sign-out-clicked'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.signOut"
        })
      })
    })]
  });
};